import $ from 'jquery';

export default class WCProductCustomTypesSelect {
    constructor() {
        this.attributeSelect = [
            ...document.querySelectorAll('.jsRadioAttributeSelect'),
        ];

        this.typeRadioSelection = document.querySelector(
            '.jsVariationSelection',
        );

        if (this.typeRadioSelection) {
            this.typeRadios = [
                ...this.typeRadioSelection.querySelectorAll(
                    'input[type="radio"]',
                ),
            ];
        }

        this.events();
    }

    events() {
        if (
            this.typeRadios &&
            this.typeRadios.length &&
            this.attributeSelect.length
        ) {
            this.typeRadios.forEach((radio) =>
                radio.addEventListener('change', this.typeChanged.bind(this)),
            );

            // The reset link of the variations form clears the selection -
            // show the type choice as not selected as well
            document.addEventListener('click', (e) => {
                if (
                    !(e.target instanceof Element) ||
                    !e.target.closest(
                        '.jsVariableProductForm .reset_variations',
                    )
                )
                    return;

                this.resetTypeRadios();
            });

            // WooCommerce announces a reset for pointer and keyboard alike
            // (Enter / Space on the link fire no click event)
            $('.jsVariableProductForm').on('announce_reset', () =>
                this.resetTypeRadios(),
            );
        }
    }

    resetTypeRadios() {
        this.typeRadios.forEach((radio) => {
            radio.checked = false;
        });
    }

    typeChanged(ev) {
        let selectedOption = null;
        const selectedRadio = ev.currentTarget;
        const selectedRadioAttribute = selectedRadio.getAttribute('name');
        const selectedRadioValue = selectedRadio.value;
        const attrSearchValue = selectedRadioAttribute.replace('-radio', '');
        const selectInUse = document.getElementById(attrSearchValue);

        if (!selectInUse) return;

        const allOptions = [...selectInUse.children];

        allOptions.forEach((option, idx) => {
            option.removeAttribute('selected');

            if (selectedRadioValue === option.value) {
                option.setAttribute('selected', 'selected');
                selectInUse.selectedIndex = idx;
                selectedOption = option;
            }
        });

        // used jquery to trigger custom jquery woocommerce event
        $(selectedOption).trigger('change');
    }
}
